
import React from "react";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Board } from "@/contexts/boards";
import { SidebarMenuItem } from "@/components/ui/sidebar/components/menu";
import BoardItem from "./BoardItem";

interface BoardListProps {
  boards: Board[];
  isLoading: boolean;
  draggingId: string | null;
  dropTargetId: string | null;
  contentDropTargetId: string | null;
  onDragStart: (e: React.DragEvent, id: string) => void;
  onDragOver: (e: React.DragEvent, id: string) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent, id: string) => void;
  onDragEnd: () => void;
  onContentDragOver: (e: React.DragEvent, id: string) => void;
  onContentDrop: (e: React.DragEvent, id: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

const BoardList: React.FC<BoardListProps> = ({
  boards,
  isLoading,
  draggingId,
  dropTargetId,
  contentDropTargetId,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
  onContentDragOver,
  onContentDrop,
  onEdit,
  onDelete
}) => {
  const location = useLocation();
  
  return (
    <>
      {isLoading ? (
        <SidebarMenuItem className="h-8">
          <div className="px-3 py-0 text-sm text-clustr-mediumGray">Loading boards...</div>
        </SidebarMenuItem>
      ) : boards && boards.length > 0 ? (
        boards.map((board, index) => (
          <SidebarMenuItem 
            key={`board-${board.id}`} 
            className={cn("mb-2", {
              "mb-2": index < boards.length - 1,
            })}
          >
            <BoardItem
              board={board}
              isActive={location.pathname === `/board/${board.id}`}
              draggingId={draggingId}
              dropTargetId={dropTargetId}
              contentDropTargetId={contentDropTargetId}
              onDragStart={onDragStart}
              onDragOver={onDragOver}
              onDragLeave={onDragLeave}
              onDrop={onDrop}
              onDragEnd={onDragEnd}
              onContentDragOver={onContentDragOver}
              onContentDrop={onContentDrop}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </SidebarMenuItem>
        ))
      ) : (
        <SidebarMenuItem className="h-8">
          <div className="px-3 py-0 text-sm text-clustr-mediumGray">No boards yet</div>
        </SidebarMenuItem>
      )}
    </>
  );
};

export default BoardList;
